import React, { FC, useState } from "react";
import IconButton from "@mui/material/IconButton"
import ShareIconCard from "/src/assets/svg/card-icons-pack/share-icon.svg?react"
import { Popover, Stack } from "@mui/material";
import TextField from "@mui/material/TextField";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import Skype from "../../../assets/svg/socials-icons/Skype.svg?react"
import VK from "../../../assets/svg/socials-icons/Vkontakte.svg?react"
import WatsApp from "../../../assets/svg/socials-icons/WhatsApp.svg?react"
import Telegram from "../../../assets/svg/socials-icons/Telegram.svg?react"
import useScreenSize from "@utils/useScreenSize";
import NativeShareDialog from "@components/Dialogs/NativeShareDialog";

export  interface  SimpleSharedDialogProps {
  sharedLink: string
  title?: string
  text?: string
}
const SimpleSharedDialog: FC<SimpleSharedDialogProps> = ({sharedLink, text, title}) => {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null)
  const isNativeSharedAvalible = navigator.share !== undefined
  const screenSize = useScreenSize()
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = () => {
    setAnchorEl(null)
  }
  const copyClipboard = async() => {
     await navigator.clipboard.writeText(sharedLink)
  }
  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;
  return <>
    <IconButton aria-describedby={id} onClick={handleClick}>
      <ShareIconCard fill={"var(--secondary-text)"}  />
    </IconButton>
    {(isNativeSharedAvalible && screenSize === "mobile") ?
      <NativeShareDialog onClose={handleClose} sharedLink={sharedLink} text={text} title={title} open={open}/>:
      (
      <Popover
        id={id}
        open={open}
        disableScrollLock={true}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'center',
          horizontal: 'center',
        }}
      >
        <Stack gap="8px" direction="column">
          <Stack alignItems="center" gap={2}  direction="row" margin="8px">
            <TextField
              variant="outlined"
              fullWidth
              value={sharedLink} />
            <IconButton onClick={copyClipboard}>
              <ContentCopyIcon htmlColor="var(--Schemes-On-Surface-Variant)"  />
            </IconButton>
          </Stack>
          <Stack  alignContent="center" justifyContent="space-evenly" margin="8px 48px 8px 12px" direction="row">
            <VK height={40} width={40} />
            <WatsApp height={40} width={40} />
            <Telegram height={40} width={40}  />
          </Stack>
        </Stack>
      </Popover>
    )}

  </>

}
export default SimpleSharedDialog